module.exports = __webpack_public_path__ + "img/b1-2.bc7cc22.png";